export default {
  SHARED_FOOTER_SIMPLE: {
    COPYRIGHT: '© {{year}}, Legal Labs Kft.',
    TERMS_AND_CONDITIONS: 'Terms and Conditions',
    PRIVACY_POLICY: 'Privacy Policy',
    HELP: 'Help',
  },
};
